"use client"

/**
 * The membership-first site's blood test treatment for the single-biomarker
 * landings (Lp(a), PSA, cortisol), the same as on the /tests blood pages
 * (Eugene, 01.10: "the same approach on every blood test"): the plan card
 * and the other blood tests on top of it, the quiz banner, and the fresh
 * step photos. Inside MriPlanScope.
 */

import { QuizCtaBanner } from "@/components/marketing/quiz-cta-banner"
import type { BiomarkerLandingConfig } from "@/components/ui/biomarker-landing"
import { PlanBloodAddons } from "./pricing-v5-client"
import { BloodPlanCard, PLAN_STEP_IMAGES } from "./pricing-v5-mri-cards"

/** The plan card, the blood tests without the page's own, the quiz banner. */
export function PlanBloodBlock({
  addonKey,
  track,
}: {
  addonKey?: string
  track: string
}) {
  return (
    <section
      data-testid="plan-block"
      className="bg-background pt-16 pb-16 md:pt-20 md:pb-24"
    >
      <div className="px-4 md:px-10">
        <BloodPlanCard track={track} />
      </div>
      <div className="mt-16 px-4 md:mt-24 md:px-10">
        <PlanBloodAddons exclude={addonKey} />
      </div>
      <div className="mx-auto mt-16 max-w-[1120px] px-4 md:mt-24 md:px-10 xl:px-0">
        <QuizCtaBanner variant="compact" />
      </div>
    </section>
  )
}

/**
 * The landing's steps with the plan site's photos for booking and the
 * visit; the third step keeps its own report picture.
 */
export function withPlanSteps(
  config: BiomarkerLandingConfig
): BiomarkerLandingConfig {
  return {
    ...config,
    steps: {
      ...config.steps,
      items: config.steps.items.map((item, i) =>
        i < 2 && item.image
          ? {
              ...item,
              image: {
                ...item.image,
                src: PLAN_STEP_IMAGES[i],
                position: undefined,
                quality: 90,
              },
            }
          : item
      ),
    },
  }
}
